import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";

import { Toaster } from "react-hot-toast";
import App from "./App.tsx";
import ReactGA from "react-ga4";
import "./i18n/config.ts";
import "./main.css";
import { ErrorBoundary } from '@highlight-run/react';
import { TrackerService } from "./services/tracker.service.ts";

TrackerService.init()
const queryClient = new QueryClient();

import.meta.env.VITE_GA_MEASUREMENT_ID &&
  ReactGA.initialize(import.meta.env.VITE_GA_MEASUREMENT_ID);

console.log("VITE_GA_MEASUREMENT_ID :::", import.meta.env.VITE_GA_MEASUREMENT_ID);


ReactDOM.createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        toastOptions={{
          style: {
            padding: 0,
            margin: 0,
            backgroundColor: "#FCE4E4",
            minWidth: "560px",
          },
        }}
      />
    </QueryClientProvider>
  </ErrorBoundary>
);
